function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Diagrams/Active/Line");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hover",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(-463.000000, -84.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Diagrams/Active/Line",
  transform: "translate(463.000000, 84.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.363342, 4.500000)",
  stroke: "#FFFFFF",
  strokeWidth: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.48458144,-3.01980663e-14 C6.92186951,-3.01980663e-14 8.14700621,1.52518655 9.15999154,4.57555965 C7.97600035,6.32940601 7.0072,9.19679821 6.25309977,13.1782837 L6.25309977,13.1782837 L0.57577404,13.1782837 C0.29964417,13.178261 0.0757966822,12.9544136 0.0757966822,12.6782837 C0.0757966822,12.6543131 0.0775205319,12.6303734 0.0809548925,12.6066501 C1.29764112,4.2022167 3.09884997,-3.01980663e-14 5.48458144,-3.01980663e-14 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3520998,3.58333946 C14.7734671,3.58333946 16.4018752,6.7439732 17.2373242,13.0652407 C17.2444972,13.1199682 17.2060008,13.1701901 17.1512811,13.1774221 C17.1469397,13.1779959 17.1425654,13.1782837 17.1381863,13.1782837 L7.13976644,13.1782837 L7.13976644,13.1782837 C8.17889706,6.7816542 9.9163415,3.58333946 12.3520998,3.58333946 Z",
  id: "Path-6-Copy"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}))));

var SvgLine = function SvgLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/line.31cae768.svg";
export { ForwardRef as ReactComponent };